export const pl = {
  Anuluj: 'Anuluj',
  AnulujConfirm: 'Czy na pewno chcesz anulować? Zmiany zostaną utracone.',
  BrakUprawnien: 'Nie ma takiej strony lub nie posiadasz do niej uprawnień - skontaktuj się z administratorem',
  CtrlB: '[CTRL+B]',
  CtrlX: '[CTRL+X]',
  DEL: '[DEL]',
  Dodaj: 'Dodaj',
  DodajNaPodstawieWybranego: '[SHIFT+INS] Dodaj na podstawie wybranego',
  E: '[CTRL+X]',
  Edytuj: 'Edytuj',
  Eksportuj: 'Eksportuj',
  ENTF4: '[ENTER/F4]',
  Err_msg_default: 'Problem z komunikacją',
  Err_msg_unauthorized: 'Wpisałeś zły login lub hasło',
  F8: '[F8]',
  INS: '[INS]',
  ListaNumerowana: 'Lista numerowana',
  ListaWypunktowana: 'Lista wypunktowana',
  NewUser: 'Logowanie do systemu\n',
  NotFoundApiErr: 'Nie znaleziono szukanego rekordu',
  Refresh: 'Odśwież',
  Retry: 'Spróbuj ponownie',
  SesjaWygasla: 'Sesja wygasła',
  Tytul: 'Tytuł',
  Usun: 'Usuń',
  WgrajFolder: 'Wgraj folder',
  WgrajTylko1Folder: 'Musisz wgrać tylko jeden folder',
  WgrajTylkoFolder: 'Możesz wgrać tylko folder',
  WgrajXLSLubXLSX: 'Wgraj plik z rozszerzeniem XLS lub XLSX',
  Zaloguj: 'Zaloguj',
  Zamknij: 'Zamknij',
  Zamknij_confirm: 'Czy na pewno chcesz zamknąć to okno?',
  ZmianaJezykaZmianyUtraconeConfirm: 'Czy na pewno chcesz zmienić język? Zmiany zostaną utracone.',
  Zobacz: 'Zobacz'
};
